import styled from 'styled-components';
import { getCDNImageUrl } from '@/helpers/cdn';
import { ScFAQByGroup } from '@/modules/restrictions/components/FAQByGroup/styled';
import { device } from '@/styles/helpers';

export const ScFaq = styled.div<{ $bgImage?: string }>`
  position: relative;
  z-index: 1;
  overflow: hidden;
  padding-top: 64px;

  @media (${device.mobile}) {
    padding-top: 32px;
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100vw;
    height: 375px;
    z-index: 0;
    pointer-events: none;
    background-image: url(${({ $bgImage }) => getCDNImageUrl($bgImage || '/headline-promo/faq-bg.svg')});
    background-position: top center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  ${ScFAQByGroup} {
    position: relative;
    z-index: 1;
    max-width: 862px;
    margin-inline: auto;
    padding: 0 16px 64px;
  }
`;
